export default [
  'deviceService',
  function (deviceService) {
    this.isMobile = deviceService.isMobile;
  },
];
